import { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import parse from 'html-react-parser';
//import { useNavigate } from 'react-router-dom';


import Menu from '../main/Menu';
import { RequestAccountReq, RequestAccountRes, } from '../../classess/account/requestAccount.js'
import { Toast, } from '../../classess/notifications/toast.js'
import { NotificationToast, } from '../../classess/main/notifications/notificationToast.js'

import {
    isUndNullEmp, getLanguageObj, getResponse, handleResponseMessageAsync, settings, styles, isValidEmail, isValidPhoneNumber, notificationsToastGetAsync,
    notificationsToastShowAsync, LoadingSection
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { RequestAccountService } from '../../services/auth/RequestAccountService';

// const $ = window.jqGlobal || window.jQuery;

const { icons, images, labels, messages, } = settings;

const currentMethod = 'RequestAccount';

export default function RequestAccount({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const reCaptchaRef = useRef(ReCAPTCHA);
    //const navigate = useNavigate();

    const getDefaultData = () => {
        return RequestAccountReq.class();
    }
    const [dataForm, setDataForm] = useState(getDefaultData());
    const [dataFormLength] = useState(RequestAccountReq.minMaxLength(false));

    // const [firstNameError, setFirstNameError] = useState('');
    // const [lastNameError, setLastNameError] = useState('');
    // const [userNameError, setUserNameError] = useState('');
    // const [phoneNumberError, setPhoneNumberError] = useState('');
    // const [nameError, setNameError] = useState('');
    // const [rifError, setRifError] = useState('');
    // const [emailError, setEmailError] = useState('');
    // const [phonesError, setPhonesError] = useState('');
    // const [departmentError, setDepartmentError] = useState('');
    // const [positionError, setPositionError] = useState('');

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        userName: '',
        phoneNumber: '',
        name: '',
        rif: '',
        email: '',
        phones: '',
        department: '',
        position: '',
    });

    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: true, save: false });
    const isMount = useRef(true);
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-light border w-100 px-4 shadow-sm font-weight-bold text-secondary',
                id: 'btnBack',
            },
            home: {
                defaultClass: 'btn btn-light border w-100 px-4 shadow-sm font-weight-bold text-secondary',
                id: 'btnHome',
            },
            request: {
                defaultClass: 'btn btn-primary w-100 px-4 shadow-sm font-weight-bold',
                id: 'btnRequest',
            },
        },
        icons: {
            request: {
                id: 'iconRequest',
                defaultClass: icons?.fasFa?.save,
            },
        },
        inputs: {
            department: {
                id: 'inputDepartment',
            },
            email: {
                id: 'inputEmail',
            },
            firstName: {
                id: 'inputFirstName',
            },
            lastName: {
                id: 'inputLastName',
            },
            name: {
                id: 'inputName',
            },
            phones: {
                id: 'inputPhones',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
            },
            position: {
                id: 'inputPosition',
            },
            rif: {
                id: 'inputRif',
            },
            userName: {
                id: 'inputUserName',
            },
        },
        spiners: {
            request: {
                id: 'spRequest',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region variables
            let notificationToastsData = [Toast?.getClass({}, false)];
            let notificationsToastObj = {
                ...NotificationToast?.getClass({}, false),
                controller: settings?.app?.views?.accounts?.accounts,
                method: settings?.app?.views?.accounts?.requestAccount,
                isAuthenticated: false,
            };
            //#endregion variables

            //#region notificationtoast (get)
            response = await notificationsToastGetAsync({
                data: notificationsToastObj,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            notificationToastsData = response?.result?.toasts || []
            //#endregion notificationtoast (get)

            //#region show toasts
            response = await notificationsToastShowAsync({
                data: notificationToastsData,
                languageId: languageObj?.id,
                window: window,
                document: document,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion show toasts

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning) {
                setShowData(false);
            }
            setProcess(prev => ({ ...prev, showLoading: false }));

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: {},
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors(prev => ({
                ...prev,
                firstName: '',
                lastName: '',
                userName: '',
                phoneNumber: '',
                name: '',
                rif: '',
                email: '',
                phones: '',
                department: '',
                position: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            let errorsObj = {
                firstName: '',
                lastName: '',
                userName: '',
                phoneNumber: '',
                name: '',
                rif: '',
                email: '',
                phones: '',
                department: '',
                position: '',
            };

            //#region global
            if (isUndNullEmp({ data: dataForm, subMethod: currentMethod })?.result) {
                errorsObj = {
                    firstName: messages?.thisFieldRequired?.[languageObj?.id],
                    lastName: messages?.thisFieldRequired?.[languageObj?.id],
                    userName: messages?.thisFieldRequired?.[languageObj?.id],
                    phoneNumber: messages?.thisFieldRequired?.[languageObj?.id],
                    name: messages?.thisFieldRequired?.[languageObj?.id],
                    rif: messages?.thisFieldRequired?.[languageObj?.id],
                    email: messages?.thisFieldRequired?.[languageObj?.id],
                    phones: messages?.thisFieldRequired?.[languageObj?.id],
                    department: messages?.thisFieldRequired?.[languageObj?.id],
                    position: messages?.thisFieldRequired?.[languageObj?.id],
                };
                response.isWarning = true;
            }
            //#endregion global

            //#region employee
            if (isUndNullEmp({ data: dataForm?.firstName, subMethod: currentMethod })?.result) {
                errorsObj.firstName = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.lastName, subMethod: currentMethod })?.result) {
                errorsObj.lastName = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.userName, subMethod: currentMethod })?.result) {
                errorsObj.userName = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            } else if (!isValidEmail({ data: dataForm?.userName })) {
                errorsObj.userName = messages?.youMustEnterValidEmail[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.phoneNumber, subMethod: currentMethod })?.result) {
                errorsObj.phoneNumber = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            } else if (!isValidPhoneNumber({ data: dataForm?.phoneNumber })) {
                errorsObj.phoneNumber = messages?.youMustEnterValidPhoneNumber[languageObj?.id];
                response.isWarning = true;
            }
            //#endregion employee

            //#region company
            if (isUndNullEmp({ data: dataForm?.name, subMethod: currentMethod })?.result) {
                errorsObj.name = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.rif, subMethod: currentMethod })?.result) {
                errorsObj.rif = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.email, subMethod: currentMethod })?.result) {
                errorsObj.email = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            } else if (!isValidEmail({ data: dataForm.email })) {
                errorsObj.email = messages?.youMustEnterValidEmail[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.phones, subMethod: currentMethod })?.result) {
                errorsObj.phones = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            } else if (!isValidPhoneNumber({ data: dataForm?.phones })) {
                errorsObj.phones = messages?.youMustEnterValidPhoneNumber[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.department, subMethod: currentMethod })?.result) {
                errorsObj.department = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.position, subMethod: currentMethod })?.result) {
                errorsObj.position = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }
            //#endregion company

            setErrors(prev => ({ ...prev, ...errorsObj }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const requestAccount = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'requestAccount';
        try {
            if (e) e?.preventDefault?.();

            //#region error default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion error default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region get / set recaptcha
            const reCaptchaToken = await reCaptchaRef?.current?.executeAsync();
            reCaptchaRef?.current?.reset();
            //#endregion get / set recaptcha

            //#region send data
            response = await RequestAccountService.requestAccountAsync({
                dataForm: {
                    ...dataForm,
                    reCaptchaToken: reCaptchaToken,
                },
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion send data

            const requestAccount = RequestAccountRes.class(
                response?.result?.requestAccount,
                false,
            );

            window.location.href = `${settings?.backend?.urls?.requestAccountDetails}/${requestAccount.id}/true`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: {},
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.main?.home} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.requestAccount?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.requestAccount?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {showData ? (
                            <div>
                                <div className='row mb-4'>
                                    <div className='col-12'>
                                        <div className='alert alert-light border-0 shadow-lg rounded-lg d-flex align-items-center' role='alert'>
                                            <div className='mr-3 text-info'>
                                                <i className={`${icons?.fasFa?.infoCircle} fa-2x`}></i>
                                            </div>
                                            <div className='text-muted small'>
                                                <div className='mb-2'>
                                                    {parse(messages?.requestAccountParagraph1?.[languageObj?.id])}:
                                                </div>
                                                <ul className='mb-0 pl-3'>
                                                    <li>{parse(messages?.requestAccountParagraph2?.[languageObj?.id])}</li>
                                                    <li>{parse(messages?.requestAccountParagraph3?.[languageObj?.id])}</li>
                                                    <li>{parse(messages?.requestAccountParagraph4?.[languageObj?.id])}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>

                                        <div className='card border-0 shadow-lg bg-white' style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            {/*Header*/}
                                            <div className='card-header bg-white border-bottom-0 pt-4 pb-2 px-4'>
                                                <div className='d-flex align-items-center w-100'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img src={images?.icons?.user} alt='UserLogin' style={styles?.cardHeaderLogo} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.requestAccount?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.user} mr-1`}></i> {labels?.personalInformation?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <form onSubmit={(e) => requestAccount({
                                                e: e,
                                                subMethod: 'requestAccountForm'
                                            })}>

                                                {/*Body*/}
                                                <div className='card-body pt-2 px-4'>

                                                    {/* Section: Personal Information */}
                                                    <div className='d-flex align-items-center mt-4 mb-3'>
                                                        <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <i className={`${icons?.fasFa?.user} text-secondary`} style={{ fontSize: '14px' }}></i>
                                                        </div>
                                                        <h6 className='mb-0 font-weight-bold text-dark'>{labels?.personalInformation?.[languageObj?.id]}</h6>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.user} /> {labels?.firstName?.[languageObj?.id]}</small>
                                                                <input autoFocus
                                                                    id={controls?.inputs?.firstName?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.firstName}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, firstName: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, firstName: '' }))}
                                                                    value={dataForm?.firstName || ''}
                                                                    placeholder={labels?.firstName?.[languageObj?.id]}
                                                                    title={labels?.firstName?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.firstName)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.user} /> {labels?.lastName?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.lastName?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.lastName}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, lastName: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, lastName: '' }))}
                                                                    value={dataForm?.lastName || ''}
                                                                    placeholder={labels?.lastName?.[languageObj?.id]}
                                                                    title={labels?.lastName?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.lastName)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.envelope} /> {labels?.email?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.userName.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.userName}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, userName: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, userName: '' }))}
                                                                    value={dataForm?.userName || ''}
                                                                    placeholder={labels?.email?.[languageObj?.id]}
                                                                    title={labels?.email?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.userName)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.phone} /> {labels?.phones?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.phoneNumber?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.phoneNumber}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, phoneNumber: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, phoneNumber: '' }))}
                                                                    value={dataForm?.phoneNumber || ''}
                                                                    placeholder={labels?.phones?.[languageObj?.id]}
                                                                    title={labels?.phones?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.phoneNumber)}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className='row border-top pt-4 mt-2'>
                                                        <div className='col-12'>
                                                            <span className='badge badge-pill badge-secondary text-uppercase mb-3 px-3' style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                                                <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.companyInformation?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div> */}

                                                    {/* Section: Company Information */}
                                                    <div className='d-flex align-items-center mt-4 mb-3'>
                                                        <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <i className={`${icons?.fasFa?.building} text-secondary`} style={{ fontSize: '14px' }}></i>
                                                        </div>
                                                        <h6 className='mb-0 font-weight-bold text-dark'>{labels?.companyInformation?.[languageObj?.id]}</h6>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.building} /> {labels?.name?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.name?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.name}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, name: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                                    value={dataForm?.name || ''}
                                                                    placeholder={labels?.name?.[languageObj?.id]}
                                                                    title={labels?.name?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.name)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.spellCheck} /> {labels?.rif?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.rif.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.rif}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, rif: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, rif: '' }))}
                                                                    value={dataForm?.rif || ''}
                                                                    placeholder={labels?.rif?.[languageObj?.id]}
                                                                    title={labels?.rif?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.rif)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.envelope} /> {labels?.email?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.email?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.email}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, email: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                                    value={dataForm?.email || ''}
                                                                    placeholder={labels?.email?.[languageObj?.id]}
                                                                    title={labels?.email?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.email)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.phone} /> {labels?.phones?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.phones?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.phones}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, phones: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, phones: '' }))}
                                                                    value={dataForm?.phones || ''}
                                                                    placeholder={labels?.phones?.[languageObj?.id]}
                                                                    title={labels?.phones?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.phones)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.fasFa?.users} /> {labels?.department?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.department?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.department}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, department: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, department: '' }))}
                                                                    value={dataForm?.department || ''}
                                                                    placeholder={labels?.department?.[languageObj?.id]}
                                                                    title={labels?.department?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.department)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}><i className={icons?.briefcase} /> {labels?.position?.[languageObj?.id]}</small>
                                                                <input id={controls?.inputs?.position?.id}
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={dataFormLength?.max?.position}
                                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, position: e?.target?.value }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, position: '' }))}
                                                                    value={dataForm?.position || ''}
                                                                    placeholder={labels?.position?.[languageObj?.id]}
                                                                    title={labels?.position?.[languageObj?.id]}
                                                                    readOnly={process?.save}
                                                                    disabled={process?.save} />
                                                                <div className='form-text mt-1' style={styles?.inputMsgAlert}>{parse(errors?.position)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/*Footer*/}
                                                <div className='card-footer border-top-0 pt-3 pb-4 px-4 bg-white'>
                                                    <div className='row justify-content-center w-100 mx-0'>
                                                        <div className='col-12 col-sm-auto px-1 mb-2 mb-sm-0'>
                                                            <button id={controls?.buttons?.request.id}
                                                                title={labels?.request?.[languageObj?.id]}
                                                                data-toggle='tooltip'
                                                                type='submit'
                                                                disabled={process?.save}
                                                                style={{ borderRadius: '5px' }}
                                                                className={`${controls?.buttons?.request?.defaultClass} ${process?.save ? settings?.react?.settings?.react?.html?.button?.classes?.disabled : ''}`}>
                                                                {!process?.save ? (
                                                                    <i id={controls?.icons?.request?.id} className={`${controls?.icons?.request?.defaultClass}`} />
                                                                ) : (
                                                                    <span id={controls?.spiners?.request?.id} className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                                )} {labels?.request?.[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                        <div className='col-12 col-sm-auto px-1 mb-2 mb-sm-0'>
                                                            <a id={controls?.buttons?.back?.id}
                                                                href={process?.save ? '/#' : settings?.backend?.urls?.login}
                                                                title={labels?.back?.[languageObj?.id]}
                                                                style={{ borderRadius: '5px' }}
                                                                className={`${controls?.buttons?.back?.defaultClass} ${process?.save ? settings?.react?.settings?.react?.html?.button?.classes?.disabled : ''}`}>
                                                                <i className={`${icons?.fasFa?.arrowAltCircleLeft}`} /> {labels?.back?.[languageObj?.id]}
                                                            </a>
                                                        </div>
                                                        <div className='col-12 col-sm-auto px-1'>
                                                            <a id={controls?.buttons?.home?.id}
                                                                href={process?.save ? '/#' : '/'}
                                                                title={labels?.home?.[languageObj?.id]}
                                                                style={{ borderRadius: '5px' }}
                                                                className={`${controls?.buttons?.home?.defaultClass} ${process?.save ? settings?.react?.settings?.react?.html?.button?.classes?.disabled : ''}`}>
                                                                <i className={`${icons?.home}`} /> {labels?.home?.[languageObj?.id]}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>

                                            <div>
                                                <ReCAPTCHA className='g-recaptcha'
                                                    hl={languageObj?.id}
                                                    ref={reCaptchaRef}
                                                    sitekey={settings?.react?.reCAPTCHA?.reCAPTCHASiteKey}
                                                    size='invisible' />
                                            </div>
                                        </div>

                                        <div className='text-muted text-center text-small'>
                                            <p>
                                                <small>
                                                    {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank'
                                                        href={settings?.react?.reCAPTCHA?.urlPrivaciConditions}
                                                        rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                                    </a>
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                {process?.showLoading ?
                                    // <div className='col-12 text-center text-muted'
                                    //     hidden={!showLoading}>
                                    //     <img alt='loading'
                                    //         src={settings?.gifs?.normal?.circle}
                                    //         height={20}
                                    //         width={20} /> {messages?.processingPleaseWait?.[languageObj?.id]}
                                    // </div>
                                    <div></div>
                                    :
                                    <div></div>
                                }
                            </>
                        )}
                    </div>
                </section>

            </div>
        </div>
    )
}